<template>
  <div class="padding-zero">
    <div class="padding-zero" v-if="this.waitingUsers.data.data">
      <div v-if="type === 'WAITING'" class="padding-zero">
        <table-header
          :filters="filteringOptions"
          :thirdFilters="secondFilteringOptions"
          :title="'Użytkownicy do zweryfikowania'"
          :withPagination="true"
          :withFilters="true"
          :withThirdFilters="true"
          :dispatchAction="'getProfileWithWatingStatus'"
          :onPage="this.waitingUsers.data.data.on_page"
          :pageNumber="this.waitingUsers.data.data.page_number"
          :total="this.waitingUsers.data.data.total_value"
          :refreshAction="true"
          :tableName="'waitingUsers'"
          :firstAdditionalButton="'Zaakceptuj użytkownika'"
          :secondAdditionalButton="'Odrzuć użytkownika'"
          :extraInputLabel="'Wiadomość do użytkownika...'"
          @firstMethodToListen="changeStatus('ACCEPTED', $event)"
          @secondMethodToListen="changeStatus('REJECTED', $event)"
          :toggleOption="'WAITING'"
          :toggleValue="false"
          @handleToggle="handleLists('FAILED')"
          :disabledFirstAdditionalButton="this.loading"
          :disabledSecondAdditionalButton="this.loading"
        ></table-header>

        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col">ID użytkownika</th>
              <th scope="col">Numer tel.</th>
              <th scope="col">Do weryfikacji</th>
              <th scope="col">Utworzono</th>
              <th scope="col">Imię</th>
              <th scope="col">Nazwisko</th>
              <th scope="col">Data urodzenia</th>
              <th scope="col">Pesel</th>
              <th scope="col">Adresy użytkownika</th>
              <th scope="col">Numer konta</th>
              <th scope="col">Czy konto bankowe zweryfikowane?</th>
              <th scope="col">Weryfikacja numeru konta</th>
              <th scope="col">Status</th>
              <th scope="col">Dystans</th>
              <th scope="col">Zdjęcie</th>
              <th scope="col">Status pracownika</th>
              <th scope="col">Usługi</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :class="{
                firstVerification:
                  !data.user_profile.profile
                    .date_of_last_verification_decision ||
                  data.user_profile.profile.need_verification_services,
                notFirstVerification:
                  data.user_profile.profile
                    .date_of_last_verification_decision !== null &&
                  !data.user_profile.profile.need_verification_services,
              }"
              v-for="data in this.waitingUsers.data.data.user_profile_service.filter(
                (data) =>
                  !acceptedOrRejectedUsersIds.includes(
                    data.user_profile.user.id
                  )
              )"
              :key="data.user_profile.user.id"
            >
              <td>
                <input
                  type="radio"
                  :id="data.user_profile.user.id"
                  name="changeStatus"
                  :value="data.user_profile.user.id"
                  @change="
                    onStatusChange(
                      $event,
                      data.user_profile.profile.need_verification_services
                    )
                  "
                />
                <label :for="data.user_profile.user.id">{{
                  data.user_profile.user.id
                }}</label>
              </td>
              <td>{{ data.user_profile.user.phone }}</td>
              <td class="changesTD">
                <b
                  ><div>
                    {{
                      !data.user_profile.profile.type_of_editing ||
                      data.user_profile.profile
                        .date_of_last_verification_decision === null
                        ? "Wszystko"
                        : data.user_profile.profile.type_of_editing ===
                          "PROFILE"
                        ? "Profil"
                        : "Usługi"
                    }}
                  </div>
                  <button
                    type="button"
                    class="btn btn-outline-dark btn-sm"
                    data-toggle="modal"
                    data-target="#userChanges"
                    @click="setUserChanges(data.user_profile.user.id)"
                  >
                    Zmiany
                  </button></b
                >
              </td>
              <td>{{ data.user_profile.user.creation_date }}</td>
              <td>{{ data.user_profile.profile.first_name }}</td>
              <td>{{ data.user_profile.profile.last_name }}</td>
              <td>
                {{
                  data.user_profile.profile.birthdate
                    ? formattedDateWithoutTime(
                        data.user_profile.profile.birthdate
                      )
                    : "Brak"
                }}
              </td>
              <td>
                {{
                  data.user_profile.profile.pesel
                    ? data.user_profile.profile.pesel
                    : "Brak"
                }}
              </td>
              <td>
                <button
                  type="button"
                  class="btn btn-outline-dark"
                  data-toggle="modal"
                  :data-target="`#address${data.user_profile.user.id}`"
                >
                  Pokaż
                </button>
              </td>
              <td>{{ data.user_profile.profile.account_number }}</td>
              <td>
                {{
                  data.user_profile.profile.payment_verification_status ===
                  "ACCEPTED"
                    ? "Tak"
                    : "Nie"
                }}
              </td>
              <td
                v-if="
                  !data.user_profile.profile.payment_verification_status ||
                  data.user_profile.profile.payment_verification_status ===
                    'NOT_INITIALIZED'
                "
              >
                Nie rozpoczęto płatności weryfikacyjnej
              </td>
              <td
                v-if="
                  data.user_profile.profile.payment_verification_status ===
                  'ACCEPTED'
                "
              >
                Płatność weryfikacyjna zakończona pomyślnie
              </td>
              <td
                v-if="
                  data.user_profile.profile.payment_verification_status ===
                  'REJECTED'
                "
              >
                Płatność weryfikacyjna zakończona niepowodzeniem
              </td>
              <td
                v-if="
                  data.user_profile.profile.payment_verification_status ===
                  'CREATED'
                "
              >
                Płatność weryfikacyjna rozpoczęta, lecz niedokończona
              </td>

              <td>{{ data.user_profile.profile.profile_status }}</td>
              <td>{{ data.user_profile.profile.distance }}</td>
              <td>
                <a
                  target="_blank"
                  :href="
                    getUrl() +
                    '/api/profile/photo/' +
                    data.user_profile.profile.file_path
                  "
                >
                  <img
                    class="img-avatar"
                    :src="
                      getUrl() +
                      '/api/profile/photo/' +
                      data.user_profile.profile.file_path
                    "
                  />
                </a>
              </td>
              <td>{{ data.user_profile.profile.employee_status }}</td>

              <td>
                <button
                  v-if="data.user_services && data.user_services.length > 0"
                  type="button"
                  class="btn btn-outline-dark"
                  data-toggle="modal"
                  :data-target="`#services${data.user_profile.user.id}`"
                  @click="fetchUserServices(data.user_profile.user.id)"
                >
                  Pokaż
                </button>
                <div v-else>Brak</div>
              </td>

              <!-- Usługi użytkownika -->
              <div
                class="modal fade"
                :id="`services${data.user_profile.user.id}`"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">
                        Usługi użytkownika
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <table class="table modal-table">
                        <thead>
                          <tr class="tr-table">
                            <th scope="col">Cena</th>
                            <th scope="col">ID usługi</th>
                            <th scope="col">Kategoria</th>
                            <th scope="col">Podkategoria</th>
                            <th scope="col">Nazwa usługi</th>
                            <th scope="col">Opis usługi</th>
                            <th scope="col">Pierwszy próg</th>
                            <th scope="col">Drugi próg</th>
                            <th scope="col">Typ</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in data.user_services"
                            :key="item.id"
                            :style="
                              item.service.need_verification ? 'color:red' : ''
                            "
                          >
                            <td>{{ item.price }}</td>
                            <td>{{ item.service.id }}</td>
                            <td>
                              {{
                                item.service.serviceCategoryEntity
                                  ? item.service.serviceCategoryEntity
                                      .display_name
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                item.service.sub_category
                                  ? item.service.sub_category.display_name
                                  : "Brak"
                              }}
                            </td>
                            <td>{{ item.service.display_name }}</td>
                            <td>{{ item.service.description || "Brak" }}</td>
                            <td>{{ item.service.first_threshold }}</td>
                            <td>{{ item.service.second_threshold }}</td>
                            <td>{{ item.service.type }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-outline-dark"
                        data-dismiss="modal"
                      >
                        Zamknij
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Zmiany do weryfikacji -->
              <div
                class="modal fade"
                id="userChanges"
                tabindex="-1"
                role="dialog"
                aria-labelledby="userChangesLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="userChanges">
                        Zmiany do weryfikacji
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="changes = null"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <table
                        class="table modal-table"
                        v-if="changes && changes.length > 0"
                      >
                        <thead>
                          <tr class="tr-table">
                            <th scope="col">ID</th>
                            <th scope="col">Zmienione pole</th>
                            <th scope="col">Data</th>
                            <th scope="col">Poprzednia wartość</th>
                            <th scope="col">Nowa wartość</th>
                            <th scope="col">Rodzaj zmiany</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in changes" :key="item.id">
                            <td>{{ item.id }}</td>
                            <td>{{ item.changed_field }}</td>
                            <td>{{ formattedDate(item.creationDate) }}</td>
                            <td>
                              <span v-if="item.change_type === 'SERVICES'">
                                <ul
                                  style="list-style-type: decimal"
                                  v-if="item.before_change.split(',')[0]"
                                >
                                  <span
                                    v-for="service in item.before_change.split(
                                      ','
                                    )"
                                    :key="service"
                                  >
                                    {{ service }}
                                  </span>
                                </ul>
                                <div v-else>Brak usług</div>
                              </span>
                              <span v-else>
                                {{
                                  item.before_change
                                    ? item.before_change
                                    : "Brak"
                                }}
                              </span>
                            </td>
                            <td>
                              <span v-if="item.change_type === 'SERVICES'">
                                <ul style="list-style-type: decimal">
                                  <span
                                    v-for="service in item.after_change.split(
                                      ','
                                    )"
                                    :key="service"
                                  >
                                    {{ service }}
                                  </span>
                                </ul>
                              </span>
                              <span v-else>
                                {{ item.after_change }}
                              </span>
                            </td>
                            <td>{{ item.change_type }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div v-else>
                        <div class="alert alert-danger notFoundListAlert">
                          Brak informacji o zmianach
                        </div>
                      </div>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-outline-dark"
                        data-dismiss="modal"
                        @click="changes = null"
                      >
                        Zamknij
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Adresy użytkownika -->
              <div
                class="modal fade"
                :id="`address${data.user_profile.user.id}`"
                tabindex="-1"
                role="dialog"
                aria-labelledby="address"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="address">
                        Adresy użytkownika
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="changes = null"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <h4>Adres do faktury</h4>
                      <table class="table modal-table">
                        <thead>
                          <tr class="tr-table">
                            <th scope="col">Kod pocztowy</th>
                            <th scope="col">Miasto</th>
                            <th scope="col">Ulica</th>
                            <th scope="col">Numer budynku</th>
                            <th scope="col">Numer mieszkania</th>
                            <th scope="col">Piętro</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>
                              {{
                                data.user_profile.profile.postcode_invoice
                                  ? data.user_profile.profile.postcode_invoice
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.user_profile.profile.city_invoice
                                  ? data.user_profile.profile.city_invoice
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.user_profile.profile.street_invoice
                                  ? data.user_profile.profile.street_invoice
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.user_profile.profile.number1_invoice
                                  ? data.user_profile.profile.number1_invoice
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.user_profile.profile.number2_invoice
                                  ? data.user_profile.profile.number2_invoice
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.user_profile.profile.floor_invoice
                                  ? data.user_profile.profile.floor_invoice
                                  : "Brak"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <h4>Adres świadczenia usług</h4>
                      <table class="table modal-table">
                        <thead>
                          <tr class="tr-table">
                            <th scope="col">Kod pocztowy</th>
                            <th scope="col">Miasto</th>
                            <th scope="col">Ulica</th>
                            <th scope="col">Numer budynku</th>
                            <th scope="col">Numer mieszkania</th>
                            <th scope="col">Piętro</th>
                            <th scope="col">Latitude</th>
                            <th scope="col">Longitude</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>
                              {{
                                data.user_profile.profile.employee_postcode
                                  ? data.user_profile.profile.employee_postcode
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.user_profile.profile.employee_city
                                  ? data.user_profile.profile.employee_city
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.user_profile.profile.employee_street
                                  ? data.user_profile.profile.employee_street
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.user_profile.profile.employee_number1
                                  ? data.user_profile.profile.employee_number1
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.user_profile.profile.employee_number2
                                  ? data.user_profile.profile.employee_number2
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.user_profile.profile.employee_floor
                                  ? data.user_profile.profile.employee_floor
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.user_profile.profile.employee_latitude
                                  ? data.user_profile.profile.employee_latitude
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.user_profile.profile.employee_longitude
                                  ? data.user_profile.profile.employee_longitude
                                  : "Brak"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <span
                        v-if="
                          data.user_profile.profile.distance &&
                          data.user_profile.profile.postcode
                        "
                      >
                        Promień świadczenia usług:
                        {{ data.user_profile.profile.distance }}km
                      </span>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-outline-dark"
                        data-dismiss="modal"
                        @click="changes = null"
                      >
                        Zamknij
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="type === 'FAILED'" class="padding-zero">
        <table-header
          :title="'Użytkownicy z nieudaną próbą weryfikacji konta bankowego'"
          :withPagination="true"
          :dispatchAction="'fetchWaitingUsersWithoutPayment'"
          :onPage="this.waitingUsersWithoutPayment.data.on_page"
          :pageNumber="this.waitingUsersWithoutPayment.data.page_number"
          :total="this.waitingUsersWithoutPayment.data.total_value"
          :refreshAction="true"
          :tableName="'waitingUsersWithoutPayments'"
          :firstAdditionalButton="'Zaakceptuj użytkownika'"
          :secondAdditionalButton="'Odrzuć użytkownika'"
          :thirdAdditionalButton="'Oznacz konto bankowe jako zweryfikowane'"
          :extraInputLabel="'Wiadomość do użytkownika...'"
          @firstMethodToListen="changeStatus('ACCEPTED', $event)"
          @secondMethodToListen="changeStatus('REJECTED', $event)"
          @thirdMethodToListen="
            changePaymentVerificationStatus('acceptAccount')
          "
          @handleToggle="handleLists('WAITING')"
          :toggleOption="'FAILED'"
          :toggleValue="true"
        ></table-header>
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col">ID użytkownika</th>
              <th scope="col">Numer tel.</th>
              <th scope="col">Do weryfikacji</th>
              <th scope="col">Utworzono</th>
              <th scope="col">Imię</th>
              <th scope="col">Nazwisko</th>
              <th scope="col">Data urodzenia</th>
              <th scope="col">Pesel</th>
              <th scope="col">Adresy użytkownika</th>
              <th scope="col">Dane przypisane do konta bankowego</th>
              <th scope="col">Numer konta</th>
              <th scope="col">Czy konto bankowe zweryfikowane?</th>
              <th scope="col">Weryfikacja numeru konta</th>
              <th scope="col">Status</th>
              <th scope="col">Dystans</th>
              <th scope="col">Zdjęcie</th>
              <th scope="col">Status pracownika</th>
              <th scope="col">Usługi</th>
            </tr>
          </thead>

          <tbody>
            <tr
              :class="{
                firstVerification:
                  !data.profileResponse.date_of_last_verification_decision,
                notFirstVerification:
                  data.profileResponse.date_of_last_verification_decision ==
                  true,
              }"
              v-for="data in this.waitingUsersWithoutPayment.data.list"
              :key="data.profileResponse.id"
            >
              <td>
                <input
                  type="radio"
                  :id="data.user_id"
                  name="changeStatus"
                  :value="data.user_id"
                  @change="onStatusChange($event)"
                />
                <label :for="data.user_id">{{ data.user_id }}</label>
              </td>
              <td>{{ data.phone }}</td>
              <td class="changesTD">
                <button
                  type="button"
                  class="btn btn-outline-dark btn-sm"
                  data-toggle="modal"
                  data-target="#userChanges"
                  @click="setUserChanges(data.user_id)"
                >
                  Zmiany
                </button>
              </td>
              <td>{{ formattedDate(data.creation_date) }}</td>
              <td>{{ data.profileResponse.first_name }}</td>
              <td>{{ data.profileResponse.last_name }}</td>
              <td>
                {{ formattedDateWithoutTime(data.profileResponse.birthdate) }}
              </td>
              <td>{{ data.profileResponse.pesel }}</td>
              <td>
                <button
                  type="button"
                  class="btn btn-outline-dark"
                  data-toggle="modal"
                  :data-target="`#address${data.profileResponse.id}`"
                >
                  Pokaż
                </button>
              </td>
              <td>
                <button
                  type="button"
                  class="btn btn-outline-dark"
                  data-toggle="modal"
                  :data-target="`#accountData${data.profileResponse.id}`"
                >
                  Pokaż
                </button>
              </td>
              <td>{{ data.profileResponse.account_number }}</td>
              <td>
                {{
                  data.profileResponse.payment_verification_status ===
                  "ACCEPTED"
                    ? "Tak"
                    : "Nie"
                }}
              </td>
              <td
                v-if="
                  !data.profileResponse.payment_verification_status ||
                  data.profileResponse.payment_verification_status ===
                    'NOT_INITIALIZED'
                "
              >
                Nie rozpoczęto płatności weryfikacyjnej
              </td>
              <td
                v-if="
                  data.profileResponse.payment_verification_status ===
                  'ACCEPTED'
                "
              >
                Płatność weryfikacyjna zakończona pomyślnie
              </td>
              <td
                v-if="
                  data.profileResponse.payment_verification_status ===
                  'REJECTED'
                "
              >
                Płatność weryfikacyjna zakończona niepowodzeniem
              </td>
              <td
                v-if="
                  data.profileResponse.payment_verification_status === 'CREATED'
                "
              >
                Płatność weryfikacyjna rozpoczęta, lecz niedokończona
              </td>

              <td>{{ data.profileResponse.profile_status }}</td>
              <td>{{ data.profileResponse.distance }}</td>
              <td>
                <a
                  target="_blank"
                  :href="
                    getUrl() +
                    '/api/profile/photo/' +
                    data.profileResponse.file_path
                  "
                >
                  <img
                    class="img-avatar"
                    :src="
                      getUrl() +
                      '/api/profile/photo/' +
                      data.profileResponse.file_path
                    "
                  />
                </a>
              </td>
              <td>{{ data.profileResponse.employee_status }}</td>
              <td>
                <button
                  v-if="data.user_services && data.user_services.length > 0"
                  type="button"
                  class="btn btn-outline-dark"
                  data-toggle="modal"
                  :data-target="`#services${data.profileResponse.id}`"
                  @click="fetchUserServices(data.profileResponse.id)"
                >
                  Pokaż
                </button>
                <div v-else>Brak</div>
              </td>

              <!-- Usługi użytkownika -->
              <div
                class="modal fade"
                :id="`services${data.profileResponse.id}`"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">
                        Usługi użytkownika
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <table class="table modal-table">
                        <thead>
                          <tr class="tr-table">
                            <th scope="col">Cena</th>
                            <th scope="col">ID usługi</th>
                            <th scope="col">Kategoria</th>
                            <th scope="col">Podkategoria</th>
                            <th scope="col">Nazwa usługi</th>
                            <th scope="col">Opis usługi</th>
                            <th scope="col">Pierwszy próg</th>
                            <th scope="col">Drugi próg</th>
                            <th scope="col">Typ</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            v-for="item in data.user_services"
                            :key="item.id"
                            :style="
                              item.service.need_verification ? 'color:red' : ''
                            "
                          >
                            <td>{{ item.price }}</td>
                            <td>{{ item.service.id }}</td>
                            <td>
                              {{
                                item.service.serviceCategoryEntity
                                  ? item.service.serviceCategoryEntity
                                      .display_name
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                item.service.sub_category
                                  ? item.service.sub_category.display_name
                                  : "Brak"
                              }}
                            </td>
                            <td>{{ item.service.display_name }}</td>
                            <td>{{ item.service.description || "Brak" }}</td>
                            <td>{{ item.service.first_threshold }}</td>
                            <td>{{ item.service.second_threshold }}</td>
                            <td>{{ item.service.type }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-outline-dark"
                        data-dismiss="modal"
                      >
                        Zamknij
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Zmiany do weryfikacji -->
              <div
                class="modal fade"
                id="userChanges"
                tabindex="-1"
                role="dialog"
                aria-labelledby="userChangesLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="userChanges">
                        Zmiany do weryfikacji
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="changes = null"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <table
                        class="table modal-table"
                        v-if="changes && changes.length > 0"
                      >
                        <thead>
                          <tr class="tr-table">
                            <th scope="col">ID</th>
                            <th scope="col">Zmienione pole</th>
                            <th scope="col">Data</th>
                            <th scope="col">Poprzednia wartość</th>
                            <th scope="col">Nowa wartość</th>
                            <th scope="col">Rodzaj zmiany</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in changes" :key="item.id">
                            <td>{{ item.id }}</td>
                            <td>{{ item.changed_field }}</td>
                            <td>{{ formattedDate(item.creationDate) }}</td>
                            <td>
                              <span v-if="item.change_type === 'SERVICES'">
                                <ul
                                  style="list-style-type: decimal"
                                  v-if="item.before_change.split(',')[0]"
                                >
                                  <span
                                    v-for="service in item.before_change.split(
                                      ','
                                    )"
                                    :key="service"
                                  >
                                    {{ service }}
                                  </span>
                                </ul>
                                <div v-else>Brak usług</div>
                              </span>
                              <span v-else>
                                {{ item.before_change }}
                              </span>
                            </td>
                            <td>
                              <span v-if="item.change_type === 'SERVICES'">
                                <ul style="list-style-type: decimal">
                                  <span
                                    v-for="service in item.after_change.split(
                                      ','
                                    )"
                                    :key="service"
                                  >
                                    {{ service }}
                                  </span>
                                </ul>
                              </span>
                              <span v-else>
                                {{ item.after_change }}
                              </span>
                            </td>
                            <td>{{ item.change_type }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div v-else>
                        <div class="alert alert-danger notFoundListAlert">
                          Brak informacji o zmianach
                        </div>
                      </div>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-outline-dark"
                        data-dismiss="modal"
                        @click="changes = null"
                      >
                        Zamknij
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Dane bankowe -->
              <div
                class="modal fade"
                :id="`accountData${data.profileResponse.id}`"
                tabindex="-1"
                role="dialog"
                aria-labelledby="accountData"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="accountData">
                        Porównanie danych personalnych
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="changes = null"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <h4>Dane przypisane do konta bankowego</h4>
                      <table class="table modal-table">
                        <thead>
                          <tr class="tr-table">
                            <th scope="col">Imię</th>
                            <th scope="col">Nazwisko</th>
                            <th scope="col">Numer konta</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>
                              {{
                                data.bank_first_name
                                  ? data.bank_first_name
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.bank_last_name
                                  ? data.bank_last_name
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.bank_account ? data.bank_account : "Brak"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <h4>Dane w aplikacji</h4>
                      <table class="table modal-table">
                        <thead>
                          <tr class="tr-table">
                            <th scope="col">Imię</th>
                            <th scope="col">Nazwisko</th>
                            <th scope="col">Numer konta</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>
                              {{
                                data.profileResponse.first_name
                                  ? data.profileResponse.first_name
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.profileResponse.last_name
                                  ? data.profileResponse.last_name
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.profileResponse.account_number
                                  ? data.profileResponse.account_number
                                  : "Brak"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-outline-dark"
                        data-dismiss="modal"
                        @click="changes = null"
                      >
                        Zamknij
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Adresy użytkownika -->
              <div
                class="modal fade"
                :id="`address${data.profileResponse.id}`"
                tabindex="-1"
                role="dialog"
                aria-labelledby="address"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="address">
                        Adresy użytkownika
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="changes = null"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>

                    <div class="modal-body">
                      <h4>Adres do faktury</h4>
                      <table class="table modal-table">
                        <thead>
                          <tr class="tr-table">
                            <th scope="col">Kod pocztowy</th>
                            <th scope="col">Miasto</th>
                            <th scope="col">Ulica</th>
                            <th scope="col">Numer budynku</th>
                            <th scope="col">Numer mieszkania</th>
                            <th scope="col">Piętro</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>
                              {{
                                data.profileResponse.postcode_invoice
                                  ? data.profileResponse.postcode_invoice
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.profileResponse.city_invoice
                                  ? data.profileResponse.city_invoice
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.profileResponse.street_invoice
                                  ? data.profileResponse.street_invoice
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.profileResponse.number1_invoice
                                  ? data.profileResponse.number1_invoice
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.profileResponse.number2_invoice
                                  ? data.profileResponse.number2_invoice
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.profileResponse.floor_invoice
                                  ? data.profileResponse.floor_invoice
                                  : "Brak"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <h4>Adres świadczenia usług</h4>
                      <table class="table modal-table">
                        <thead>
                          <tr class="tr-table">
                            <th scope="col">Kod pocztowy</th>
                            <th scope="col">Miasto</th>
                            <th scope="col">Ulica</th>
                            <th scope="col">Numer budynku</th>
                            <th scope="col">Numer mieszkania</th>
                            <th scope="col">Piętro</th>
                            <th scope="col">Latitude</th>
                            <th scope="col">Longitude</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>
                              {{
                                data.profileResponse.employee_postcode
                                  ? data.profileResponse.employee_postcode
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.profileResponse.employee_city
                                  ? data.profileResponse.employee_city
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.profileResponse.employee_street
                                  ? data.profileResponse.employee_street
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.profileResponse.employee_number1
                                  ? data.profileResponse.employee_number1
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.profileResponse.employee_number2
                                  ? data.profileResponse.employee_number2
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.profileResponse.employee_floor
                                  ? data.profileResponse.employee_floor
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.profileResponse.employee_latitude
                                  ? data.profileResponse.employee_latitude
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                data.profileResponse.employee_longitude
                                  ? data.profileResponse.employee_longitude
                                  : "Brak"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <span
                        v-if="
                          data.profileResponse.distance &&
                          data.profileResponse.postcode
                        "
                      >
                        Promień świadczenia usług:
                        {{ data.profileResponse.distance }}km
                      </span>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-outline-dark"
                        data-dismiss="modal"
                        @click="changes = null"
                      >
                        Zamknij
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import shared from "../shared";
import axios from "../axios";
import { URL } from "../axios";
import TableHeader from "../components/TableHeader.vue";

export default {
  name: "WaitingUsers",
  components: { TableHeader },
  computed: {
    waitingUsers() {
      return this.$store.getters.getWaitingUsers;
    },
    waitingUsersWithoutPayment() {
      return this.$store.getters.getWaitingUsersWithoutPayment;
    },
    employeeStatus() {
      return this.$store.getters.getEmployeeStatus;
    },
  },
  created() {
    this.$store.dispatch("fetchWaitingUsersWithoutPayment", {
      on_page: 20,
      page_number: 1,
    });
    this.$store.dispatch("getProfileWithWatingStatus", {
      on_page: this.waitingUsers.pagination.on_page,
      page_number: this.waitingUsers.pagination.page_number,
    });
    this.formattedDate = shared.formattedDate;
    this.formattedDateWithoutTime = shared.formattedDateWithoutTime;
  },
  methods: {
    handleLists(list) {
      this.type = list;
    },
    changePaymentVerificationStatus(type) {
      let confirmed;
      if (this.id === null) {
        this.$notify({
          group: "error",
          text: "Wybierz użytkownika",
        });
      } else {
        if (type === "acceptAccount") {
          confirmed = prompt(
            `Czy na pewno oznaczyć numer konta jako zweryfikowany? Potwierdź wpisując 'ZWERYFIKOWANE'`,
            ""
          );
        } else {
          confirmed = "ZWERYFIKOWANE";
        }
        if (confirmed === "ZWERYFIKOWANE") {
          axios
            .put(
              `/api/profile/${this.id}/paymentVerificationStatus?status=ACCEPTED`
            )
            .then(() => {
              this.$store.dispatch("fetchWaitingUsersWithoutPayment", {
                on_page: this.waitingUsersWithoutPayment.data.on_page,
                page_number: this.waitingUsersWithoutPayment.data.page_number,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    fetchUserServices(userId) {
      const url = `/api/user/${userId}/userServices`;
      axios
        .get(url)
        .then((response) => {
          this.services = response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchData() {
      this.$store.dispatch("getProfileWithWatingStatus", {
        on_page: this.waitingUsers.pagination.on_page,
        page_number: this.waitingUsers.pagination.page_number,
        sort_by: this.sortingParam,
        sort_type: this.sortingType,
        filter_param: this.searchParam,
      });
    },
    setUserChanges(userId) {
      const url = `/api/profileChange/${userId}`;
      axios
        .get(url)
        .then((response) => {
          this.changes = response.data;
        })
        .catch((err) => console.log(err));
    },
    getUrl() {
      return URL;
    },
    changeListType() {
      if (this.type === "WAITING") {
        this.type = "FAILED";
      } else {
        this.type = "WAITING";
      }
    },
    onStatusChange(e, needVerification) {
      this.id = e.target.value;
      this.needVerificationServices = needVerification;
    },
    async changeStatus(employee_status, emitBody) {
      if (this.needVerificationServices && employee_status === "ACCEPTED") {
        const confirmed = prompt(
          `Czy na pewno chcesz zaakceptować tego opiekuna?\n\nŚwiadczy on usługi, które wymagają zweryfikowania prawa wykonywania zawodu. \n\nJeśli chcesz kontynuować akceptację opiekuna potwierdź wpisując 'TAK'`,
          ""
        );
        if (confirmed !== "TAK") {
          return;
        }
      }

      this.loading = true;
      try {
        const rejectedMessage = emitBody.emitParam;
        if (this.id === null) {
          this.$notify({
            group: "error",
            text: "Wybierz użytkownika",
          });
          this.loading = false;
        } else {
          if (employee_status === "REJECTED" && !rejectedMessage.length) {
            this.$notify({
              group: "error",
              text: "Wymagane jest podanie przyczyny odrzucenia użytkownika!",
            });
            this.loading = false;
            return false;
          } else {
            try {
              const response = await this.$store.dispatch(
                "changeEmployeeStatus",
                {
                  id: this.id,
                  employee_status: employee_status,
                  message: rejectedMessage,
                }
              );
              if (response) {
                this.acceptedOrRejectedUsersIds.push(this.id);
                console.log("response");
                if (employee_status === "ACCEPTED") {
                  this.changePaymentVerificationStatus();
                }

                await this.$store.dispatch(
                  "getProfileWithWatingStatus",
                  emitBody
                );

                await this.$store.dispatch(
                  "fetchWaitingUsersWithoutPayment",
                  emitBody
                );
                this.loading = false;
                this.rejectedMessage = "";
                if (employee_status === "REJECTED") {
                  this.$notify({
                    group: "success",
                    text: "Pomyślnie odrzucono użytkownika!",
                  });
                } else {
                  this.$notify({
                    group: "success",
                    text: "Pomyślnie zaakceptowano użytkownika!",
                  });
                }
              }
              this.needVerificationServices = false;
              this.loading = false;
            } catch (error) {
              console.log(error);
            }
          }
        }
      } catch (err) {
        console.log(err);
        this.$notify({
          group: "success",
          text: "Nie udało się zmienić statusu użytkownika",
        });
        this.loading = false;
      }
    },
    requestPhoto(id) {
      let url = "api/profile/photo/" + id;
      axios.get(url).then((response) => {
        const img = Buffer.from(response.data, "binary").toString("base64");
        return "data:image/png;base64," + img;
      });
    },
  },
  data() {
    return {
      acceptedOrRejectedUsersIds: [],
      needVerificationServices: false,
      loading: false,
      id: null,
      type: "WAITING",
      rejectedMessage: "",
      changes: [],
      searchParam: "",
      services: [],
      filteringOptions: [
        {
          name: "first_name",
          displayName: "Imie",
        },
        {
          name: "last_name",
          displayName: "Nazwisko",
        },
        {
          name: "modification_date",
          displayName: "Data modyfikacji",
        },
        {
          name: "phone",
          displayName: "Telefon",
        },
        {
          name: "pesel",
          displayName: "Pesel",
        },
      ],
      secondFilteringOptions: [
        {
          name: "asc",
          displayName: "Rosnąco",
        },
        {
          name: "desc",
          displayName: "Malejąco",
        },
      ],
    };
  },
};
</script>

<style scoped>
.firstVerification {
  background: rgb(235, 119, 90);
}
.notFirstVerification {
  background: rgb(243, 227, 195);
}
td,
table tbody tr:not(:last-child) {
  border: none;
}
</style>
